import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, Typography, Chip, Stack, Paper, Grid, Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import Slider from 'react-slick';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import packagesData from '../data/package.json';
import packageData from '../data/packages.json';


const PackageDetails = () => {
  const { destinationId, packageId } = useParams();


  const destinationFromPackageJson = packagesData.find(p => p.id === destinationId);
  const flatPackage = packageData.find(p => p.id == packageId || p.destinationId === destinationId);
  
  // Determine which package to use
  let selectedPackage = null;
  
  if (destinationFromPackageJson?.packages) {
    selectedPackage = destinationFromPackageJson.packages.find(p => p.id == packageId);
  }
  
  if (!selectedPackage && flatPackage) {
    selectedPackage = flatPackage;
  }
  

  if (!selectedPackage) {
    return (
      <Box p={4}>
        <Typography variant="h5" color="error">Package not found</Typography>
      </Box>
    );
  }

  const sliderSettings = {
    dots: true,
    customPaging: (i) => (
      <img
        src={selectedPackage.images[i]}
        alt={`thumb-${i}`}
        style={{
          width: 30,
          height: 30,
          objectFit: 'cover',
          borderRadius: 4,
          border: '2px solid transparent',
        }}
      />
    ),
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Box py={{ xs: 7, md: 10, lg:10 }} px={3}>
      <Grid container spacing={3} py={5}>
        {/* Image Slider */}
        <Grid item size={{xs:12, sm:6, md:8, lg:8}}>
          <Box mb={4}>
            <Slider {...sliderSettings}>
              {selectedPackage.images.map((img, index) => (
                <Box key={index} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                  <img
                    src={img}
                    alt={`slide-${index}`}
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: 400,
                      objectFit: 'cover',
                      borderRadius: 8,
                    }}
                  />
                </Box>
              ))}
            </Slider>
          </Box>
        </Grid>

        {/* Package Info */}
        <Grid item size={{xs:12, sm:6, md:4, lg:4}}>
          <Paper
            sx={{
              boxShadow: 4,
              borderRadius: 2,
              padding: 3,
              height: '100%',
            }}
          >
            <Typography variant="h4" mb={2}>
              {selectedPackage.name}
            </Typography>
            <Typography variant="body1" mb={1}>
              <strong>Duration:</strong> {selectedPackage.duration}
            </Typography>
            <Typography variant="body1" mb={1}>
              <strong>Price:</strong> {selectedPackage.price}
            </Typography>
            <Typography variant="body1" mb={1}>
              <strong>Description:</strong> {selectedPackage.description}
            </Typography>

            {selectedPackage.inclusions?.length > 0 && (
              <>
                <Typography variant="h6" mt={3}>Inclusions:</Typography>
                <Stack direction="row" spacing={1} mt={1} mb={2} flexWrap="wrap">
                  {selectedPackage.inclusions.map((item, idx) => (
                    <Chip key={idx} label={item} sx={{ backgroundColor: "#0e8279", color: "white" }} />
                  ))}
                </Stack>
              </>
            )}

            {selectedPackage.details && (
              <Typography variant="body2">{selectedPackage.details}</Typography>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* Overview */}
      {selectedPackage.overview && (
        <Box mt={6} p={3} sx={{
          backgroundColor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          boxShadow: 1,
        }}>
          <Typography variant="h5" gutterBottom>
            Overview
          </Typography>
          {Object.entries(selectedPackage.overview).map(([day, detail], idx) => (
            <Accordion key={idx} defaultExpanded={idx === 0} sx={{
              my: 2,
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 2
            }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {`Day ${idx + 1}`}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">{detail}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PackageDetails;
